import { createSelector } from "reselect";
import {
  orderRefSelector,
  orderIdSelector,
  orderDetailsSelector
} from "ducks/selectors";
import get from "lodash/get";
import map from "lodash/map";
import find from "lodash/find";
import moment from "moment";

const suspendNumberDomain = state =>
  get(state, "form.SuspendNumberForm.values", {});

// ***************************************************************
// ************** SuspendNumberForm selectors ******************
// ***************************************************************

export const suspendNumberSelector = createSelector(
  suspendNumberDomain,
  suspendNumber => suspendNumber
);

// ***************************************************************
// ************** SuspendNumberForm makeSelect *****************
// ***************************************************************

export const getOrderDetails = state => {
  return get(state, "api.orderDetails.data", null);
};

export const makeSelectedSuspensionStartDate = () =>
  createSelector(suspendNumberDomain, suspendNumberForm => {
    return get(suspendNumberForm, "suspension_start_date.value");
  });

export const makeSelectedSuspensionEndDate = () =>
  createSelector(suspendNumberDomain, suspendNumberForm => {
    return get(suspendNumberForm, "suspension_end_date.value");
  });

export const makeSelectedFormattedSuspensionStartDate = () =>
  createSelector(
    suspendNumberDomain,
    orderDetailsSelector,
    (suspendNumberForm, orderDetails) => {
      const startDate =
        get(suspendNumberForm, "suspension_start_date.value") ||
        get(orderDetails, "start_date");
      return {
        label: moment(startDate).format("DD MMMM YYYY"),
        value: startDate
      };
    }
  );

export const makeSelectedFormattedSuspensionEndDate = () =>
  createSelector(
    suspendNumberDomain,
    orderDetailsSelector,
    (suspendNumberForm, orderDetails) => {
      const endDate =
        get(suspendNumberForm, "suspension_end_date.value") ||
        get(orderDetails, "end_date");
      return {
        label: moment(endDate).format("DD MMMM YYYY"),
        value: endDate
      };
    }
  );

export const makeSelectSuspensionStartDates = () =>
  createSelector(orderDetailsSelector, orderDetails => {
    return map(get(orderDetails, "suspension_date"), ({ start_date }) => {
      return {
        label: moment(start_date).format("DD MMMM YYYY"),
        value: start_date
      };
    });
  });

export const makeSelectSuspensionEndDates = () =>
  createSelector(
    orderDetailsSelector,
    suspendNumberSelector,
    (orderDetails, suspendNumberForm) => {
      const startDate = find(
        get(orderDetails, "suspension_date", []),
        ({ start_date }) => {
          return (
            start_date === get(suspendNumberForm, "suspension_start_date.value")
          );
        }
      );

      return map(get(startDate, "end_date"), ({ date }) => {
        return {
          label: moment(date).format("DD MMMM YYYY"),
          value: date
        };
      });
    }
  );

export const makeSuspendNumberFormInitialValues = () =>
  createSelector(orderDetailsSelector, orderDetails => {
    return {
      phone_number: get(orderDetails, "phone_number"),
      doc_type: { value: get(orderDetails, "doc_type") }
    };
  });

export const makeSelectSuspendNumberFormPayload = () =>
  createSelector(
    orderRefSelector,
    orderIdSelector,
    orderDetailsSelector,
    suspendNumberSelector,
    (orderRef, orderId, orderDetails, suspendNumberForm) => {
      //base on v1.
      return {
        nric: get(suspendNumberForm, "nric"),
        order_id: orderId,
        order_ref: orderRef,
        start_date: get(suspendNumberForm, "suspension_start_date.value"),
        end_date: get(suspendNumberForm, "suspension_end_date.value"),
        phone_number: get(orderDetails, "phone_number"),
        amount_per_month: get(orderDetails, "price_per_month"),
        out_standing_amount: get(orderDetails, "amount", 0)
      };
    }
  );

export const makeSelectCancelSuspendNumberPayload = () =>
  createSelector(orderRefSelector, orderIdSelector, (orderRef, orderId) => {
    //base on v1.
    return {
      order_id: orderId,
      order_ref: orderRef
    };
  });
